// extracted by mini-css-extract-plugin
export default {"external":"aiQu2p","wrapper":"biQu2p"};